<script setup lang="ts">
import { EventsLineupsParticipant } from '@collector/sportsapi-client-legacy'
import { useLineupsSelectOptions } from '@mobile/views/Relation/Shared/Lineups/useLineupsSelectOption'
import { IncidentActionComposable } from '@mobile/views/Relation/Shared/Popup/useIncidentAction'
import { ProbableLinkedParticipant } from '@mobile/views/Relation/Shared/RelationDependencies/types'
import SelectPlayer from '@mobile/views/Relation/Shared/SelectPlayer/SelectPlayer.vue'

type Props = {
  incidentActionSubstitutionIn: IncidentActionComposable
  incidentActionSubstitutionOut: IncidentActionComposable
  probableLinkedParticipant: ProbableLinkedParticipant
}

const props = defineProps<Props>()

const {
  selectedMainParticipant: subbedInParticipant,
  mainLineupsParticipants,
  secondaryLineupsParticipants,
  lineupsSelectOptions,
  updateMainParticipant: updateSubbedInParticipant,
} = useLineupsSelectOptions(
  props.incidentActionSubstitutionIn.getProbableIncident(),
  props.probableLinkedParticipant.side,
)

const {
  selectedMainParticipant: subbedOutParticipant,
  updateMainParticipant: updateSubbedOutParticipant,
} = useLineupsSelectOptions(
  props.incidentActionSubstitutionOut.getProbableIncident(),
  props.probableLinkedParticipant.side,
)

function assignPlayerToSubstitutionOut(
  participant: EventsLineupsParticipant | null,
): void {
  updateSubbedOutParticipant(participant?.participant_id)
  props.incidentActionSubstitutionOut.updateIncident({
    participant_team_id: participant?.participant_team_id,
    subparticipant_id: participant?.participant_id,
    subparticipant_name: participant?.participant_name,
  })
}

function assignPlayerToSubstitutionIn(
  participant: EventsLineupsParticipant | null,
): void {
  updateSubbedInParticipant(participant?.participant_id)
  props.incidentActionSubstitutionIn.updateIncident({
    participant_team_id: participant?.participant_team_id,
    subparticipant_id: participant?.participant_id,
    subparticipant_name: participant?.participant_name,
  })
}
</script>

<template>
  <div class="flex flex-1 space-x-6">
    <div class="flex w-full">
      <SelectPlayer
        :selectedPlayer="subbedOutParticipant"
        :lineupsSelectOptions
        :players="mainLineupsParticipants"
        :selectLabel="{ text: 'Out', classes: 'text-base font-bold w-12 mr-3' }"
        @selectedPlayerChanged="assignPlayerToSubstitutionOut"
      />
      <div class="mx-3"></div>
      <SelectPlayer
        :selectedPlayer="subbedInParticipant"
        :lineupsSelectOptions
        :players="secondaryLineupsParticipants"
        :selectLabel="{ text: 'In', classes: 'text-base font-bold w-12 mr-3' }"
        @selectedPlayerChanged="assignPlayerToSubstitutionIn"
      />
    </div>
  </div>
</template>
